var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    width: 10,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffc307",
    height: 36,
    rx: 18,
    width: 36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.782 10.989c.013-.6-.01-.985-.01-.985h-11.86s-.022.381-.01.985H8v.644c0 .147.025 3.616 2.166 5.516a4.839 4.839 0 003.321 1.192c.2 0 .4-.013.61-.031a5.7 5.7 0 002.577 2.093v2.83h-2.846v1.77h-.94v1H22.8v-1h-.941v-1.768h-2.844v-2.832a5.7 5.7 0 002.578-2.094c.208.018.413.031.611.031a4.839 4.839 0 003.32-1.192c2.141-1.9 2.166-5.369 2.166-5.516v-.643zm-12.757 5.2a6.294 6.294 0 01-1.691-3.911h2.647a12.884 12.884 0 00.983 4.065c.111.244.229.476.348.7a3.552 3.552 0 01-2.287-.854zm13.639 0a3.547 3.547 0 01-2.287.856c.12-.226.237-.458.348-.7a12.864 12.864 0 00.983-4.065h2.647a6.293 6.293 0 01-1.691 3.909z",
    fill: "#fff"
  })));
}

export default SvgIcnAward;